<template>
    <b-navbar :class="navbarClasses" class="w-100" toggleable="lg">
        <div class="container-fluid">
            <!-- Language Switcher - Top Right -->
            <div class="language-switcher d-none d-lg-block">
                <a v-if="$i18n.locale !== 'pt'" :class="textClass" href="#" @click.prevent="setLocale('pt')" class="lang-link">PT</a>
                <a v-if="$i18n.locale !== 'en'" :class="textClass" href="#" @click.prevent="setLocale('en')" class="lang-link">EN</a>
            </div>
            <b-navbar-brand class="d-block d-lg-none">
                <div class="nav-link pt-0">
                    <img class="img-fluid" :src="logoSrc" alt="Logo"
                        title="Logo" />
                </div>
            </b-navbar-brand>
            <b-collapse class="nav-menu justify-content-between d-none d-lg-flex flex-column" is-nav>
                <b-navbar-brand class="mt-2 mb-4">
                    <div class="nav-link pt-0">
                        <img class="img-fluid" :src="logoSrc" alt="Logo" title="Logo" />
                    </div>
                </b-navbar-brand>
                <b-navbar-nav class="ml-auto fw-bold" :class="opacityClass">
                    <b-nav-form v-for="link in navLinks" :key="link.id">
                        <router-link :class="textClass" :to="link.to" active-class="active" exact>{{ link.label }}</router-link>
                    </b-nav-form>
                </b-navbar-nav>
            </b-collapse>
            <b-button class="d-lg-none p-0" id="navbar-toggle" v-b-toggle.sidebar-right variant="transparent" @click="toggleMobileMenu">
                <b-icon icon="list" :variant="iconVariant"></b-icon>
            </b-button>
            <b-sidebar class="w-100" id="sidebar-right" title="Sidebar" right no-header bg-variant="no-light">
                <template #default="{ hide }">
                    <SideMenu @close="hide"></SideMenu>
                </template>
            </b-sidebar>
        </div>
    </b-navbar>
</template>

<script>
import SideMenu from '@/components/menus/SideMenu.vue';

export default {
    components: {
        SideMenu
    },
    props: {
        customStyles: {
            type: Object,
            default: () => ({
                background: 'navbar-default-background',
                text: 'navbar-default-text'
            })
        }
    },
    data() {
        return {
            navLinks: [
                { id: 1, to: { name: 'HomePage' }, label: this.$t("header.home").toUpperCase() },
                { id: 2, to: { name: 'StaticInfos', params: { slug: 'projeto' } }, label: this.$t("header.projeto").toUpperCase() },
                { id: 3, to: { name: 'StaticInfos', params: { slug: 'terroir' } }, label: this.$t("header.terroir").toUpperCase() },
                { id: 4, to: { name: 'wine' }, label: this.$t("header.wine").toUpperCase() },
                { id: 5, to: { name: 'Liquor' }, label: this.$t("header.liquor").toUpperCase() },
                { id: 6, to: { name: 'OliveOil' }, label: this.$t("header.azeites").toUpperCase() },
                { id: 7, to: { name: 'Gallery' }, label: this.$t("header.galeria").toUpperCase() },
                { id: 8, to: { name: 'EntriesPage' }, label: this.$t("vueRoutes.entriesTitle").toUpperCase() }
            ]
        };
    },
    computed: {
        navbarClasses() {
            return [this.customStyles.background];
        },
        textClass() {
            return this.customStyles.text;
        },
        opacityClass() {
            return {
                'opacity-active': this.$route.name === 'OliveOilDetail' || this.$route.name === 'wineDetail' || this.$route.name === 'LiquorDetail' ||
                    (this.$route.name === 'StaticInfos' && (this.$route.params.slug === 'legal' || this.$route.params.slug === 'qualidade' || this.$route.params.slug === 'cookies' || this.$route.params.slug === 'privacy'))
            };
        },
        logoSrc() {
            return this.$route.name === 'OliveOilDetail' || this.$route.name === 'wineDetail' || this.$route.name === 'LiquorDetail' || this.$route.name === 'Gallery' || 
                (this.$route.name === 'StaticInfos' && (this.$route.params.slug === 'legal' || this.$route.params.slug === 'qualidade' || this.$route.params.slug === 'cookies' || this.$route.params.slug === 'privacy'))
                ? require('@/assets/img/Transparent.png')
                : require('@/assets/img/Transparent.png');
        },
        iconVariant() {
            return this.$route.name === 'OliveOilDetail' || this.$route.name === 'wineDetail' || this.$route.name === 'LiquorDetail' || this.$route.name === 'Gallery' || 
                (this.$route.name === 'StaticInfos' && (this.$route.params.slug === 'legal' || this.$route.params.slug === 'qualidade' || this.$route.params.slug === 'cookies' || this.$route.params.slug === 'privacy'))
            ? 'black' 
            : 'white';
        }
    },
    methods: {
        setLocale(locale) {
            this.$i18n.locale = locale;
            localStorage.setItem('locale', locale);
            window.location.href = '/';
        },
        toggleMobileMenu () {
            document.body.classList.add('overflow-hidden');
        }
    }
};
</script>

<style scoped>
/* Background and text colors for the default navbar */
.navbar-default-background {
    background-color: transparent;
}

.navbar-default-text {
    color: #fff;
}

.navbar-default-text.active {
    color: #fff;
}

/* Styles for pages with opacity active class */
.opacity-active a:not(.active),
.lang-opacity a:not(.active) {
    opacity: 1 !important;
}

/* General navbar styles */
.form-inline .form-inline a {
    font-size: 0.8rem;
    padding-left: 1rem;
    padding-right: 1rem;
    letter-spacing: .1rem;
    transition: all 0.4s ease-in-out;
    cursor: pointer;
    text-decoration: none;
}

.navbar-brand {
    width: auto;
    height: 70px;
}

.navbar-brand img {
    width: auto;
    height: 64px;
}

.form-inline {
    display: flex;
}

:deep(.b-sidebar) {
    width: 100%;
}

/* Specific navbar styles for active */
.form-inline a:not(.active) {
    opacity: 0.6;
}

.form-inline a:active,
.form-inline a:hover {
    opacity: 1;
}

.btn-check:focus+.btn,
.btn:focus {
    box-shadow: none !important;
}

#navbar-toggle {
    font-size: 2rem;
}

/* Language Switcher Styles */
.language-switcher {
    position: absolute;
    top: 15px;
    right: 20px;
    z-index: 1000;
}

.lang-link {
    font-size: 0.9rem;
    font-weight: bold;
    padding: 0.5rem 0.8rem;
    text-decoration: none;
    border-radius: 4px;
    transition: all 0.3s ease;
    letter-spacing: 0.1rem;
}

.lang-link:hover {
    opacity: 0.8;
    transform: scale(1.05);
}

/* Media query for smaller screens */
@media (max-width: 992px) {

    #navbar-toggle {
        font-size: 1.5rem;
    }

    .navbar-brand img {
        height: 50px;
    }
}
</style>
